import { createContext, useCallback, useContext, useState } from "react";

type Context = {
  registered: string[];
  register: (id: string) => void;
  unregister: (id: string) => void;
  reset: () => void;
};

/**
 * context used to register ActionItems open / close state
 * sample use case: only one pop up will be allowed to render on the screen
 */
const ActionsMenuContext = createContext<Context>({
  registered: [],
  register: () => null,
  unregister: () => null,
  reset: () => null,
});

export const ActionsMenuContextProvider = ({ children }) => {
  const [registered, setRegistered] = useState<string[]>([]);
  const register = useCallback(
    (id: string) => setRegistered((s) => (s.includes(id) ? s : [...s, id])),
    [setRegistered],
  );

  const unregister = useCallback(
    (id: string) => setRegistered((s) => s.filter((el) => el !== id)),
    [setRegistered],
  );

  const reset = useCallback(() => setRegistered([]), []);

  return (
    <ActionsMenuContext.Provider
      value={{
        reset,
        registered,
        register,
        unregister,
      }}
    >
      {children}
    </ActionsMenuContext.Provider>
  );
};

export const useActionsMenu = () => useContext(ActionsMenuContext);
